<template>
    <div :class="{'open': is_open}">
        <div class="mini-cart">
            <span class="close" @click="close">⒳</span>

            <div class="box">
                <div class="info">
                    <h2 class="title">Cart</h2>
                </div>
                <div class="list">
                    <div class="item" v-for="(item, key) in products" :key="key">
                        <div class="img">
                            <span class="remove" @click="deleteItem(item)">⒳</span>
                            <img :src="item.image">
                        </div>
                        <div class="meta">
                            <header>
                                <h3>
                                    <Link :post_link="item.link" v-html="item.name"></Link>
                                </h3>
                                <p v-if="item.variation && item.variation.attribute_pa_size">Size: <span>{{item.variation.attribute_pa_size}}</span></p>
                            </header>
                            <div class="number">
                                <div class="less" @click="updateCartItem('less', item)">-</div>
                                <div class="quantity">{{item.quantity.value}}</div>
                                <div class="plus" @click="updateCartItem('plus', item)">+</div>
                                <div class="price" v-if="item.totals && item.totals.total">
                                    £{{parseFloat(item.totals.total).toFixed(2)}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <p class="empty" v-if="!is_loading && products.length === 0">Your cart is empty.</p>
                </div>
                <div class="foot">
                    <div class="subtotal">
                        <h4><span>Subtotal</span> <strong>{{total_price}}</strong></h4>
                        <p>Delivery: Calculated on checkout</p>
                    </div>

                    <div :class="{'actived': products.length !== 0}" class="checkout-button" @click="gotoCheckout">Proceed to checkout</div>
                </div>
            </div>

            <Loading v-if="is_loading" class="absolute" />
        </div>
        <div class="mini-cart-bg" @click="close"></div>
    </div>
</template>

<script>
// import '@/assets/svg/close.svg?sprite';

import Link from '@/components/ui/Link.vue';
import Loading from '@/components/ui/Loading.vue';

import { EventBus } from '@/events/bus.js';

export default {
    name: 'mini-cart',

    data() {
        return {
            products: '',
            is_loading: true,
            is_open: false,
        }
    },
    computed: {
        total_price () {
            let price = 0;

            for (const value of Object.values(this.products)) {
                price = price + parseFloat(value.totals.total);
            }
            return price.toFixed(2);
        }
    },
    components: {
        Link,
        Loading,
    },

    methods: {
        getCart() {
            this.is_loading = true;

            this.$cart('cart', {
                method: 'get',
            }).then((response) => {
                this.updateCart(response.data);
            });
        },

        updateCart(data) {
            this.products = data.items;

            let count = 0;

            if (data.items) {
                Object.values(data.items).forEach(function(item) {
                    count = count + item.quantity.value;
                });
            }

            EventBus.$emit('cart.update.count', count);

            this.is_loading = false;
        },

        setCartCount(count) {
            let mini_cart = document.getElementById('js-cart-count');

            if (count === 0) {
                mini_cart.removeAttribute('data-count');
            } else {
                mini_cart.setAttribute('data-count', count);
            }
        },

        deleteItem(product) {
            this.is_loading = true;
            this.$cart(`cart/item/${product.item_key}`, {
                method: 'delete',
            }).then((response) => {
                this.updateCart(response.data);
            });
        },

        updateCartItem(type, product) {
            let quantity = 0;
            switch (type) {
                case 'plus':
                    quantity = product.quantity.value + 1;
                    break;
                case 'less':
                    quantity = product.quantity.value - 1;
                    break;
            }

            if (quantity === 0) {
                this.deleteItem(product);
                return;
            }

            this.is_loading = true;
            this.$cart(`cart/item/${product.item_key}`, {
                method: 'post',
                data: {
                    quantity: quantity.toString(),
                }
            }).then((response) => {
                this.updateCart(response.data);
            });

        },

        close() {
            this.is_open = false;
        },

        open() {
            this.is_open = true;
        },

        gotoCheckout() {
            const cartKey = localStorage.getItem('cocart_cart_key');
            const url = window.globals.home_url + '/checkout'
                + (cartKey ? '?cocart-load-cart=' + cartKey : '');
            window.location.href = url;
        },
    },


    mounted() {
        this.getCart();

        EventBus.$on('cart.close', () => {
            this.close();
        });

        EventBus.$on('cart.open', (is_update_cart = false) => {
            this.open();

            if (is_update_cart) {
                this.getCart();

                setTimeout(() => {
                    this.close();
                }, 2000);
            }
        });
    },
}

</script>
<style lang="scss">
.mini-cart {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 99999;
    background-color: white;
    height: 100%;
    box-shadow: 3px 0 20px 0 rgba(0, 0, 0, 0);
    width: 32rem;
    transform: translate(100%, 0);
    transition: all .3s ease-in-out;
    border-left: var(--line-2) solid;


    .empty {
        margin: 2rem 0;
        text-align: center;
    }

    .close {
        position: absolute;
        z-index: 9;
        right: 0;
		padding: var(--padding-50);
        cursor: pointer;
        font-size: var(--medium-size);

        svg {
            height: 100%;
            width: 100%;
            fill: none;
            stroke: black;
            stroke-miterlimit: 10;
            stroke-width: 2px;
            height: 1.4rem;
        }

    }

    .box {

        display: grid;
        grid-template-rows: auto 1fr auto;
        grid-template-columns: 100%;
        box-sizing: border-box;
        height: 100%;
    }

    .info {
        padding: var(--padding) 0;

        .title {
            margin: 0;
            line-height: 1;
            text-align: center;
            font-size: var(--medium-size);
            line-height: 1.2;
            text-transform: uppercase;
        }
    }

    .item {
        margin: var(--padding) 0;
        display: flex;

        .img {
            position: relative;
            height: 8rem;
            width: 8rem;
            min-width: 8rem;
            min-height: 8rem;
            top: .25rem;
            margin-right: var(--padding-50);



            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                left: 0;
                top: 0;
            }

            .remove {
                position: absolute;
                font-size: 3rem;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                cursor: pointer;
                color: white;
                opacity: 0;
                z-index: 3;

                svg {
                    position: absolute;
                    fill: none;
                    stroke: white;
                    stroke-miterlimit: 10;
                    stroke-width: 2px;
                    height: 1.2rem;
                    width: 1.2rem;
                }
            }

            &:hover .remove {
                opacity: 1;
            }
        }

        header {
            padding-bottom: 1rem;
            line-height: 1.2;

            p {
                display: block;
                font-size: var(--small-size);

                span {
                    text-transform: uppercase;
                }
            }
        }

        .meta {
            display: grid;
            grid-template-rows: 1fr auto;
            grid-template-columns: 100%;
            width: 100%;

        }

        .number {
            display: flex;
            align-items: center;
            width: 100%;

            .less,
            .plus {
                border: var(--line-2) solid ;
                width: 2.2rem;
                height: 2.2rem;
                line-height: 2.2rem;
                text-align: center;
                font-size: var(--small-size);
                cursor: pointer;

                &:hover {
                    background-color: var(--light-gray);
                }
            }


            .quantity {
                border-top: var(--line-2) solid ;
                border-bottom: var(--line-2) solid ;
                height: 2.2rem;
                line-height: 2.2rem;
                padding: 0 .9rem;
                font-size: var(--small-size);
            }



            .price {
                flex: 1;
                text-align: right;
                font-size: var(--small-size);
                line-height: 1;
            }
        }
    }

    .list {
        padding: 0 var(--padding);
        overflow: auto;
    }

    .foot {
        padding: 0 var(--padding) var(--padding);

        .subtotal {
            padding: 1rem 0;

            h4 {
                display: flex;
                margin: 0 0 .3rem;

                span {
                    flex: 1;
                }

                strong {

                    &::before {
                        content: '£';
                    }
                }
            }

            p {
                font-size: var(--small-size);
                text-align: center;
                color: var(--gray);
            }

        }

        .checkout-button {
            padding: 1rem;
            background: var(--gray);
            margin: 0 auto;
            box-sizing: border-box;
            display: block;
            text-align: center;
            // height: $header_size;
            line-height: 2rem;
            color: white;
            text-align: center;
            text-transform: uppercase;
            border: none;
            width: 100%;

            &.actived {
                cursor: pointer;
                background: var(--font-color);


                &:hover {
                    background: var(--gray);
                }
            }
        }

        input {
            display: block;
            margin-right: .3rem;
            position: relative;
            top: var(--line-2);
        }

        label {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: var(--small-size);
            margin: 1rem 0;
        }
    }

    .loading-wrap.absolute {
        height: 100%;
        width: 100%;
        z-index: 999;
        background: rgba(#fff, 0.5);
        pointer-events: unset;

        .lds-spinner {
            transform: translate(-50%, -50%);
        }
    }
}

.mini-cart-bg {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9998;
    background-color: white;
    height: 100%;
    width: 100%;
    cursor: pointer;
    opacity: 0;
    display: none;

}

.open > .mini-cart-bg  {
    display: block;
}

.open > .mini-cart {
    transform: translate(0%, 0);
    box-shadow: 3px 0 20px 0 rgba(0, 0, 0, 0.5);
}


 @media only screen and (max-width: 767px) {
    .mini-cart {
        width: 80%;



        .close {
            font-size: var(--large-size);



        }



        .info {

            .title {
                font-size: var(--large-size);

            }
        }

        .item {
            margin: var(--padding) 0;
            display: flex;

            .img {
                height: 18rem;
                width: 18rem;
                min-width: 18rem;
                min-height: 18rem;
                top: .25rem;

                .remove {
                    font-size: 6rem;
                }

                &:hover .remove {
                    opacity: 1;
                }
            }



            .number {
                display: flex;
                align-items: center;
                width: 100%;

                .less,
                .plus {
                    width: 6rem;
                    height: 6rem;
                    line-height: 6rem;
                }


                .quantity {
                    height: 6rem;
                    line-height: 6rem;
                    padding: 0 3rem;
                }

            }
        }



    }


    .mini-cart .foot .checkout-button {
        line-height: 9rem;
    }
 }
</style>
